module.exports = __webpack_public_path__ + "a943ad048ee81306871e4c370ecf5574.jpg";